module.exports = __webpack_public_path__ + "static/media/covid.86a14725.svg";